var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.primaryColor || 'primary'}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }